function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const AiIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.307 2.217c.053-.197.333-.197.386 0l.626 2.323a.2.2 0 0 0 .14.141l2.324.626c.197.053.197.333 0 .386l-2.323.626a.2.2 0 0 0-.141.14l-.626 2.324c-.053.197-.333.197-.386 0L17.68 6.46a.2.2 0 0 0-.14-.141l-2.324-.626c-.197-.053-.197-.333 0-.386l2.323-.626a.2.2 0 0 0 .141-.14l.626-2.324Zm-13 13c.053-.197.333-.197.386 0l.626 2.323a.2.2 0 0 0 .14.141l2.324.626c.197.053.197.333 0 .386l-2.323.626a.2.2 0 0 0-.141.14l-.626 2.324c-.053.197-.333.197-.386 0L4.68 19.46a.2.2 0 0 0-.14-.141l-2.324-.626c-.197-.053-.197-.333 0-.386l2.323-.626a.2.2 0 0 0 .141-.14l.626-2.324Zm7.168-12.273a.5.5 0 0 0-.95 0L9.48 9.162a.5.5 0 0 1-.318.318l-6.218 2.045a.5.5 0 0 0 0 .95l6.218 2.045a.5.5 0 0 1 .318.319l2.045 6.217a.5.5 0 0 0 .95 0l2.045-6.218a.5.5 0 0 1 .319-.318l6.217-2.045a.5.5 0 0 0 0-.95L14.838 9.48a.5.5 0 0 1-.318-.318l-2.045-6.218Z",
    clipRule: "evenodd"
  }));
};
export default AiIcon;